import { FormType } from '../application/formType';
import { AttributeEntityType } from './attributeEntityType';
import { AttributeUiType } from './attributeUiType';

export class AttributeDefinitionUsageReport {
  public associatedCount: number;
  public associatedType: AttributeEntityType;
  public associatedUIType: AttributeUiType;
  public associatedForms: FormUsageReport[];
  public associatedCustomViewCount: number;
  public associatedComplexFieldCount: number;
  public anyLogic: boolean;
  constructor(data: any) {
    this.associatedCount = data.associatedCount;
    this.associatedType = data.associatedType;
    this.associatedForms = data.associatedForms.map((x) => new FormUsageReport(x));
    this.associatedCustomViewCount = data.associatedCustomViewCount;
    this.associatedComplexFieldCount = data.associatedComplexFieldCount;
    this.anyLogic = data.anyLogic;
    this.associatedUIType = data.associatedUIType;
  }

  public get associatedUageTypeName(): string {
    switch (this.associatedType) {
      case AttributeEntityType.Person:
        return 'People';
      case AttributeEntityType.Team:
        return 'Teams';
      case AttributeEntityType.Seat:
        return 'Seats';
      case AttributeEntityType.Survey:
        return 'Surveys response';
      case AttributeEntityType.Evaluation:
        return 'Evaluations response';
      default:
        return '';
    }
  }

  public get isUsed(): boolean {
    return (
      this.associatedCount > 0 ||
      this.associatedForms.length > 0 ||
      this.associatedCustomViewCount > 0 ||
      this.associatedComplexFieldCount > 0 ||
      this.anyLogic
    );
  }
}

export class FormUsageReport {
  public id: string;
  public title: string;
  public formType: FormType;
  public isClosed: boolean;
  public get formTypeName(): string {
    switch (this.formType) {
      case FormType.Application:
        return 'Lineup Form';
      case FormType.Team:
        return 'Team Form';
      case FormType.Survey:
        return 'Survey';
      case FormType.Evaluation:
        return 'Evaluation';
      default:
        return '';
    }
  }

  constructor(data: any) {
    this.id = data.id;
    this.title = data.title;
    this.formType = data.formType;
    this.isClosed = data.isClosed;
  }
}
